import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { FaSearch } from 'react-icons/fa'
import ColorCode from '../Components/ColorCode'
import CreateShelfModal from '../Components/CreateShelfModal'
import Input from '../Components/Input'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { GetAllProductShelf, GetAllTransfer } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'

export default function Transfer() {
    const { isOpen, onOpen, onClose } = useDisclosure();


    const [ModelState, setModelState] = useState("");
    const [PreLoader, setPreLoader] = useState(true);



    const [Data, setData] = useState([]);
    const [SearchText, setSearchText] = useState("");
    const [CurrentPage, setCurrentPage] = useState(1);
    console.log("currentpage", CurrentPage)
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);

    //get current post

    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentShelf = Data.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    const [Result, setResult] = useState([]);
    const [TotalData, setTotalData] = useState([]);
    const [TransferId, setTransferId] = useState("");




    const GetAllShelf = async () => {
        let result = await GetAllTransfer()

        console.log("result tranfer", result);

        if (result.status === true) {
            setData(result.queryresult.transferdetails)
            setPreLoader(false)
        }
    }

    console.log("Data shelf", Data)

    const [UpdateShelfPayload, setUpdateShelfPayload] = useState({
        id: "",
        name: "",
        shelfId: "",
        store: "",
        category: ""
    });



    useEffect(() => {
        GetAllShelf()
    }, [isOpen]);
    return (
        <MainLayout>
         {
                PreLoader && (

                    <Preloader/>
                )
            }
            <Seo title="Manage Shelf" description='EKO IMS - Manage Shelf' />
            <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"} >


                <Text textTransform="capitalize">Total Product Transfer - {Data.length}</Text>

            </Flex>


            <Box height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue300" mt="32px" rounded={"8px"}>


                <TableContainer mt="32px" overflowX="auto" color="#fff"

                >
                    <Table variant='simple' size='sm'>
                        <Thead>
                            <Tr >
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Name</Th>
                                <Th color="#fff">Shelf id</Th>
                                <Th color="#fff">S--Store</Th>
                                <Th color="#fff">R--Store</Th>
                                <Th color="#fff">Qty</Th>
                                <Th color="#fff">Status</Th>
                                <Th color="#fff">Email</Th>
                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                currentShelf.map((item, i) => (
                                    <TableRow
                                        key={i}
                                        sn={i + 1}
                                        type="Transfer"
                                        productName={item.receivingshelfid.productname}
                                        productShelfId={item.receivingshelfid.productshelfid}
                                        store={item.sendingshelfid.store}
                                        storeName={item.receivingshelfid.store}
                                        status={item.status}
                                        qty={item.qtytotransfer}
                                        email={item.requesteremail}


                                    />
                                ))
                            }

                        </Tbody>

                    </Table>
                </TableContainer>

                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />

            </Box>

            <CreateShelfModal onClose={onClose} onOpen={onOpen} isOpen={isOpen} state={ModelState} updatedPayload={UpdateShelfPayload} sendingId={TransferId} />
        </MainLayout>
    )
}
